import {
  Grid,
  Typography,
  Box,
  makeStyles,
  Paper,
  Button,
} from "@material-ui/core";
import React, { Fragment, useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Skeleton } from "@material-ui/lab";
import { backend } from "../../../../api";
import { Link, useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "5px",
    marginTop: "30px",
    marginBottom: "30px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  },
  tabHeading: {
    fontSize: "32px",
    fontWeight: 550,
    margin: "0",
  },
  userName: {
    color: theme.palette.primary.dark,
    fontSize: 22,
    fontWeight: 500,
  },
  subHead: {
    margin: 0,
    fontSize: 18,
    fontWeight: 550,
    width: "150px",
  },
  contactBox: {
    display: "flex",
    flexWrap: "wrap",
    padding: "8px 0",
    margin: "0px",
    borderBottom: `1px solid ${theme.palette.secondary.dark}`,
  },
  paper: {
    padding: 5,
    textAlign: "center",
    maxHeight: 300,
    height: 300,
  },
}));

function KleverBooksCatalog(props) {
  const classes = useStyles();
  const history = useHistory();
  const [books, setBooks] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchAllBooks = () => {
    backend
      .get(`/adverbook/downloadedbooks?user=${props.user._id}`)
      .then(({ data }) => {
        const uniqueBooks = data.data.filter((i) => !i.expired);
        setBooks(uniqueBooks);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.response ? err.response.data.message : err.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchAllBooks();
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>KleverBook- d2p</title>
      </Helmet>
      <ToastContainer />
      <div className={classes.root}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
          <h2 className={classes.tabHeading}>My KleverBooks</h2>
        </Box>
        {loading ? (
          <Box>
            <Skeleton animation="wave" />
          </Box>
        ) : books.length > 0 ? (
          <Grid container spacing={2}>
            {books.map((download, index) => (
              <Grid item xs={12} md={4} lg={3} key={index}>
                <Link style={{ textDecoration: "none" }}>
                  <Paper elevation={2} className={classes.paper}>
                    <Box style={{ width: "90%", margin: "0 auto" }}>
                      <img
                        src={download?.book?.book_cover}
                        alt={download?.book?.book_title}
                        style={{
                          width: "100%",
                          height: 150,
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                    <Box style={{ margin: "0 auto", height: 70 }}>
                      <h5 style={{ fontWeight: 500, margin: "5px 0" }}>
                        {download?.book?.book_title}
                      </h5>
                    </Box>
                    <p>
                      {!download.expired ? (
                        <Button
                          onClick={() => history.push(`/kleverbook/read/${download._id}`)}
                          variant="contained"
                          style={{
                            position: "relative",
                            bottom: 10,
                            right: 0,
                          }}
                        >
                          READ
                        </Button>
                      ) : (
                        <h5 style={{ fontWeight: 500, margin: "5px 0" }}>
                          Book has expired, please download again
                        </h5>
                      )}
                    </p>
                  </Paper>
                </Link>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box className={classes.noBooksMessage}>
            <Typography variant="h2" color="error" style={{ margin: "30px auto" }}>
              No KleverBooks found
            </Typography>
          </Box>
        )}
      </div>
    </Fragment>
  );
}

export default KleverBooksCatalog;
